<template>

  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header"></i>
              <span>圈定条件</span>
            </div>
            <el-row :gutter="20">
              <el-form ref="form" :model="sizeForm" label-width="80px" size="mini">
                <el-form-item label="地区">

                  <el-select v-model="sizeForm.shengqu" @change="get_diban_zssy" placeholder="请选择省区"
                             style="margin-left: 20px">
                    <el-option v-for="item in options_shengqu_zssy"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="sizeForm.region" placeholder="请选择地办" style="margin-left: 20px">
                    <el-option v-for="item in options_diban_zssy"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>

                </el-form-item>
                <el-form-item label="出生范围">
                  <el-col :span="11">
                    <el-date-picker type="date" placeholder="选择日期" v-model="sizeForm.date1"
                                    style="width: 100%;"></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker placeholder="选择日期" v-model="sizeForm.date2" style="width: 100%;"></el-date-picker>
                  </el-col>
                </el-form-item>

                <el-form-item label="有无社保">
                  <el-radio-group v-model="sizeForm.shebao" size="medium">
                    <el-radio border label="有社保"></el-radio>
                    <el-radio border label="无社保"></el-radio>

                  </el-radio-group>
                </el-form-item>

                <el-form-item label="职业" disabled="">
                  <el-radio-group v-model="sizeForm.jobs" size="medium">
                    <el-radio border label="室内工作（如行政、程序员等）"></el-radio>
                    <el-radio border label="室外简单工作（如导游、小车司机等）"></el-radio>
                    <el-radio border label="室外复杂工作（如建筑工人、伐木工）"></el-radio>
                    <el-radio border label="学生"></el-radio>
                    <el-radio border label="退修"></el-radio>
                    <el-radio border label="无职业"></el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item label="家庭情况">
                  <el-radio-group v-model="sizeForm.family" size="medium">
                    <el-radio border label="已婚有孩"></el-radio>
                    <el-radio border label="已婚无孩"></el-radio>
                    <el-radio border label="未婚"></el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item size="large">
                  <el-button type="primary"
                             style="margin-left: 20px;background-color: rgb(46, 205, 129); border-color: rgb(46, 205, 129); color: white;"
                             @click="onSubmit">获取人群包并分析
                  </el-button>
                  <el-button>重置</el-button>
                </el-form-item>
              </el-form>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>


    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header-red"></i>
              <span>结果</span>
            </div>
            <el-row :gutter="20">
              <b-card-text>主要情况</b-card-text>
              <el-tag
                  v-for="item in ensur_tag_items"
                  :key="item.label"
                  :type="item.type"
                  effect="dark">
                {{ item.label }}
              </el-tag>

              <b-card-text>主要风险</b-card-text>
              <b-card-text style="color:#2F7BFE"> 风险点：{{ risk_desc }}</b-card-text>
              <el-table
                  :data="user_treat_hist"
                  height="466px"
                  :header-cell-style="{background:'#363944',color:'white',border:'none'}"
                  :row-class-name="tableRowClassName"
                  style="width: 100%;">
                <el-table-column type="index" label="序号" align="center"></el-table-column>
                <el-table-column label="姓名">
                  <template slot-scope="scope">
                    <span class="date">
                      {{ isDemo ? scope.row.patient_name.substring(0, 1) + "******" : scope.row.patient_name }}
                    </span>
                  </template>
                </el-table-column>

                <el-table-column prop="new_shengqu_name" label="省区"></el-table-column>
                <el-table-column prop="patient_id" v-if="false" label="patient_id"></el-table-column>
                <el-table-column prop="new_diban_name" label="地办"></el-table-column>
                <el-table-column prop="gender" label="性别"></el-table-column>
                <!--                <el-table-column prop="patient_birthday" label="出生日期"></el-table-column>-->
                <el-table-column label="出生日期">
                  <template slot-scope="scope">
                    <span class="date">
                      {{ isDemo ? "******" : scope.row.patient_birthday }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="patient_address" label="家庭住址"></el-table-column>

                <el-table-column
                    label="操作"
                    width="160">
                  <template slot-scope="scope">
                    <el-button @click="open_detail(scope.row)" type="text" size="small" style="color: #5CEAA8">详情
                    </el-button>
                  </template>
                </el-table-column>

              </el-table>

            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>


  </div>


</template>


<script>
import {Role} from "@/role";
import { buildAppWebUrl } from '@/utils/appWebUrl';

export default {
  name: "EnsuranceService",
  mounted() {
    this.get_shengqu();
    this.onSubmit();
  },
  computed: {
    isDemo: function () {
      return this.$store.getters.user_role === Role.Demo
    },
  },
  data() {
    return {
      options_diban_zssy: null,
      sizeForm: {
        name: '',
        shengqu: '湖南',
        region: '长沙一',
        date1: '',
        date2: '',
        delivery: false,
        jobs: '',
        family: '',
        type: [],
        shebao: '有社保',
        desc: ''
      },
      user_treat_hist: null,
      ensur_tag_items: null,
      risk_desc: "暂无数据",
      options_shengqu: null,
      options_shengqu_zssy: null,
    };
  },
  methods: {
    open_detail(row) {
      window.open(buildAppWebUrl(`/patient/basic?patient_id=${row.patient_id}`), '_blank', 'noopener,noreferrer');
    },
    get_shengqu() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_shengqu").then((res) => {
        this.options_shengqu = res.data.data
        this.options_shengqu_zssy = res.data.data
      })
    },
    get_diban_zssy() {
      this.sizeForm.region = ''
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_diban?province_id=" + this.sizeForm.shengqu).then((res) => {
        this.options_diban_zssy = res.data.data
      })
    },
    onSubmit() {
      console.log('submit!');
      this.$http.post(process.env.VUE_APP_API_HOST + "/service_ensurance_predict", this.sizeForm, {"content-type": "application/json"}).then((res) => {
        this.user_treat_hist = res.data.data;
        this.ensur_tag_items = res.data.tags;
        this.risk_desc = res.data.risk_desc;
      })
    },
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
  }
};
</script>


<style scoped>
.el-tag {
  margin-left: 10px
}

.el-form-item__label {
  color: red
}

.el-table /deep/ tbody tr:hover {
  color: black !important
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}
</style>
